var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-loader',{on:{"onFileLoad":_vm.onFileLoad,"onDragOver":function($event){_vm.fileDragOver = $event}}},[_vm._t("default",null,{"fileDragOver":_vm.fileDragOver})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }